import React from 'react'

const LoadingButton = ({ loading, btnText = "Submit", icon_2 = "", handler = () => { }, btn = "primary" }) => {
    return (
        <button type='submit' className={`btn btn-${btn} bg-blue`} onClick={handler} disabled={loading}>
            {
                loading ?
                    <>
                        <i className='bx bx-hourglass bx-spin me-2'></i> Submitting...
                    </> :
                    <>
                        <i className='fa fa-save me-2'></i> {btnText} {icon_2}
                    </>
            }
        </button>
    )
}

export default LoadingButton